module.exports = __webpack_public_path__ + "static/img/banner_login_1.a701848.png";


//////////////////
// WEBPACK FOOTER
// ./src/_app/wwka/src/assets/image/banner_login_1.png
// module id = dMM2
// module chunks = 63